import { ChevronRightIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '@rsos/base-components';
import { PreconfiguredMessageInterface } from '@rsos/reduxDataStore/src/features/alerts/chat.types';
import {
  ResponsesHolder,
  ResponseText,
  SuggestedResponse,
  ViewAllButton,
} from './SuggestedResponses.styles';

export interface ShownResponsesInterface {
  responses?: PreconfiguredMessageInterface[];
  handleViewClick?: () => void;
  handleResponseClick?: (response: string) => void;
}

const ShownResponses = ({
  responses = [],
  handleViewClick = () => null,
  handleResponseClick = () => null,
}: ShownResponsesInterface) => {
  return (
    <>
      <Box
        width="100%"
        horizontal
        justify="space-between"
        alignItems="center"
        mb="8px"
      >
        <Text color="primaryText" size="small" fontWeight="bold">
          Suggested Messages
        </Text>
        <ViewAllButton onClick={handleViewClick}>
          <Text color="secondaryText" mr="4px">
            View All
          </Text>
          <ChevronRightIcon
            viewboxHeight="18"
            viewboxWidth="18"
            width="12px"
            height="12px"
            color="secondaryText"
          />
        </ViewAllButton>
      </Box>
      <ResponsesHolder>
        {responses.map(response => (
          <SuggestedResponse
            onClick={() => handleResponseClick(response.body)}
            key={response.title}
          >
            <ResponseText>{response.title}</ResponseText>
          </SuggestedResponse>
        ))}
      </ResponsesHolder>
    </>
  );
};

export default ShownResponses;
